import * as yup from 'yup';

export const clientContactFormValidation = () =>
  yup.object({
    id: yup.string().nullable(),
    firstName: yup.string().nullable().required(),
    middleName: yup.string().nullable(),
    lastName: yup.string().nullable().required(),
    companyName: yup.string().nullable(),
    email: yup.string().email().nullable().required(),
    phoneNumber: yup.string().min(10).max(10).nullable(),
    functions: yup.array().of(yup.string()).nullable(),
    notes: yup.string().nullable(),
  });
